const tsTable = {
    data() {
        return {
            tsTable: {
                url: '',
                table: [],
                updateFlag: 0,
                updateFlag1: 0,
                updateFlag2: 0,
                isPage: true,
                isTabs: false,
                showSummary: false,
                more: false,
                updateConfirmFlag: 0,
                searchObj: this.defaultSearchObj()
            },
            tableKey: 0,
            loading: true,
            modifyOrder: {},
            detailsOrder: {}
        };
    },
    computed: {
        tsTableDivClass() {
            return {
                height: `calc(100% - 72px - ${this.tsTable.more ? '46' : '0' }px)`
            }
        },
        tsTableClass() {
            return `${this.tsTable.isTabs ? '' : 'no_'}tabs_${this.tsTable.more ? '' : 'no_'}more_${this.tsTable.isPage ? '' : 'no_'}page_${this.tsTable.showSummary ? '' : 'no_'}summary`;
        }
    },
    created() {
        this.getDefaultSearchObj();
    },
    methods: {
        moreSearchChange(e) {
            this.tsTable.more = e;
        },
        updateTable(data) {
            this.tsTable.table = data.table;
            this.loading = false;
        },
        loadingChange(e) {
            this.loading = e;
        },
        tableFlagAdd() {
            this.loading = true;
            this.tsTable.updateFlag = this.tsTable.updateFlag + 1;
            this.tableKey = this.tableKey + 1;
        },
        tableFlagAdd1() {
            this.loading = true;
            this.tsTable.updateFlag1 = this.tsTable.updateFlag1 + 1;
            this.tableKey = this.tableKey + 1;
        },
        tableFlagAdd2() {
            this.loading = true;
            this.tsTable.updateFlag2 = this.tsTable.updateFlag2 + 1;
            this.tableKey = this.tableKey + 1;
        },
        async handleClick() {
            this.tableFlagAdd();
        },
        getDefaultSearchObj() {
            let obj = {};
            this.moreSearchItems.forEach(item => {
                if (item.defaultSearchValue) {
                    obj[item.param] = item.defaultSearchValue;
                }
            });
            this.tsTable.searchObj = {
                ...this.tsTable.searchObj,
                ...obj
            };
        },
        defaultSearchObj() {
            let s;
            if (this.tsTable && this.tsTable.searchObj) {
                s = this.tsTable.searchObj.status;
            }
            return {
                status: s || '0'
            };
        },
        reSearch(obj) {
            this.tsTable.searchObj = this.defaultSearchObj();
            this.tsTable.searchObj = {
                ...this.tsTable.searchObj,
                ...obj
            }
            this.tableFlagAdd();
        },
        async deleteOrderFunc(row) {
            const deleteStr = `确定删除${row.id}吗？`;
            const { code } = await this.qDelete(`${this.tsTable.url}/${row.id}/deleted`, deleteStr, '取消删除');
            if (code === 200) {
                this.$message.success('删除成功！');
                this.tableFlagAdd();
            }
        },
        modify(row) {
            this.$router.push(`/modify-${this.orderUrl}/${row.id}`);
        },
        details(row) {
            window.open(`/salesweb/check-${this.orderUrl}/${row.id}`);
        },
        async done(row, order = '合同') {
            const response = await this.qPatch(`${this.tsTable.url}/${row.id}/done`, `你确定这个${order}完成了吗？`, '取消完成');
            if (response.code === 200) {
                this.$message.success(`成功完成${order}`);
                this.tableFlagAdd();
            }
        },
        async remove(row) {
            await this.deleteOrderFunc(row);
        }
      }
    
    };
    
export default tsTable;